export default "__VITE_ASSET__f949a8e6__"